import ReactPixel from 'react-facebook-pixel'
import Config from '../config/Config';

const Analytics = function(eventName, options) {
    const pixelTrack = function(eventName, options) {
        console.log('%c fb pixel eventName', 'color: white; background-color: blue;', eventName);
        console.log('%c fb pixel options', 'color: white; background-color: blue;', options)
        ReactPixel.init(Config.PIXELID);
        ReactPixel.trackCustom(eventName, options);
    }
    return pixelTrack(eventName, options);
}

export default Analytics;